import { CardConfiguration } from './card-configuration';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';
import { Router } from '@angular/router';

export class ConsumableCardConfiguration extends CardConfiguration {
    constructor(course: any, catalogProductsService: CatalogProductsService) {
        super();
        // console.log(course);
        this.tagType = 'courseware';
        this.classType = 'Courseware';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/courseware.png';
        this.expired = course.expired;
        this.clickable = !this.expired;
        this.links = [];
        this.observableAction = catalogProductsService.getCatalogProductAssignment(course.sku).do(res => this.target = ['course', res.data.id]);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/consumable-card-configuration.ts